export enum ProductsWidgetFeatureType {
  default = 'default',
  totalPremiums = 'totalPremiums',
  comprehensive = 'comprehensive',
}
